export const environment = {
  production: true,
  baseApiUrl: 'https://api-t.couchbidder.com/',
  baseAppUrl: 'https://app-t.couchbidder.com/',
  env: 'test'
};
